import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import InfoWithIconsSimple from './InfoWithIconsSimple';
import { sizes } from '../../Typography/constants/sizes';

var InfoWithIcons = function InfoWithIcons(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'base' : _ref$size,
      props = _objectWithoutPropertiesLoose(_ref, ["size"]);

  return /*#__PURE__*/React.createElement(InfoWithIconsSimple, _extends({
    lineHeight: (sizes[size] || sizes.default).lineHeight
  }, props));
};

export default InfoWithIcons;